/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDown: {
  name: 'arrow_down';
  data: string;
} = {
  name: 'arrow_down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12.75 3.75a.75.75 0 0 0-1.5 0v14.69l-5.47-5.47a.75.75 0 0 0-1.06 1.06l6.75 6.75a.748.748 0 0 0 1.06 0l6.75-6.75a.75.75 0 1 0-1.06-1.06l-5.47 5.47V3.75Z" fill="currentColor"/></svg>`
};
